<template>
  <header :class="{ 'head-fixed': false }" v-if="isAppDown">
    <div class="head-inner">
      <p class="logo-theFresh">GS THE FRESH</p>
    </div>
  </header>

  <header v-else>
    <div class="head-inner">
      <mButton v-if="!props.hideBack" type="button" class="bt-page-prev" @click="onClickBack">이전</mButton>
      <h1 class="gs-title">
        <span>{{ title }}</span>
      </h1>
      <div class="h-util">
        <mButton v-if="props.hideMypage" type="button" class="bt-mypage" @click="onClickMyPage">마이페이지</mButton>
        <mButton v-if="props.hideRefresh" type="button" class="bt-refresh" @click="onClickRefresh">새로고침</mButton>
        <mButton v-if="props.hideHome" type="button" class="bt-home" @click="onClickHome">홈으로</mButton>
      </div>
    </div>
  </header>
</template>

<script setup>
import { mButton } from '@gsretail/gssm-ui-mobile/dlvr'
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAPPstore } from '@/service/stores/cm/cmcm/APP.store'

const props = defineProps({
  hideMypage: {
    type: Boolean,
    default: true
  },
  hideRefresh: {
    type: Boolean,
    default: true
  },
  hideHome: {
    type: Boolean,
    default: false
  },
  hideBack: {
    type: Boolean,
    default: false
  }
})

const APPstore = useAPPstore()

const router = useRouter()
const route = useRoute()

const isAppDown = computed(() => route.meta.header.type === 'appdown')

const onClickBack = () => {
  router.go(-1)
}

const onClickMyPage = async () => {
  router.push({ name: 'DLMP-01-V101' })
}

const onClickRefresh = () => {
  APPstore.refreshCallback()
}

const onClickHome = () => {
  router.push({ name: 'DLDS-01-V101' })
}

const title = computed(() => route.meta.title)
</script>
<script>
export default {
  name: 'm-header'
}
</script>
